import { render, staticRenderFns } from "./PropGrantPopup.vue?vue&type=template&id=1b88d300&"
import script from "./PropGrantPopup.vue?vue&type=script&lang=js&"
export * from "./PropGrantPopup.vue?vue&type=script&lang=js&"
import style0 from "./PropGrantPopup.vue?vue&type=style&index=0&id=1b88d300&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports